import React, { useRef, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg';
import { ReactComponent as Save } from '../../assets/svg/Save.svg';
import { FaTimes } from 'react-icons/fa';
import { ReactComponent as ImageAddIcon } from '../../assets/svg/ImageAddIcon.svg';
import '../../styles/modals/StudentInfoModal.css';
import { Controller, useForm } from 'react-hook-form';
import Loading from '../Loading';
import { useNavigate } from 'react-router-dom';
import MDEditor from '@uiw/react-md-editor';
import { createUpdateCourse, createUpdateQuickTipsStudent, getCourseCategories, getLocales, getSolutionCategories, uploadFile } from '../../server/server';
import { fileSystemUrl } from '../../server/connections';
import { checkAllowedExtensions, notify } from '../../utils/util';
import CategoriesDropDown from '../courses/CategoriesDropDown';

function CreateEditTipModal({ modalIsOpen, closeModal, tip = null, reloadTips }: { modalIsOpen: any; closeModal: any; tip: any; reloadTips?: any }) {
	const [processing, setProcessing] = useState(false);
	const [categoryId, setCategoryId] = useState('Select');
	const [categories, setCategories] = useState<any>([]);

	const { register, handleSubmit, watch, reset, formState, getValues, setValue, control } = useForm({
		defaultValues: {
			title: '',
			body: '',
			explanation: '',
			categoryId: '',
		},
	});
	const { isDirty, isValid, errors } = formState;

	useEffect(() => {
		if (modalIsOpen) {
			// loadCategories();
		}
	}, [modalIsOpen]);

	useEffect(() => {
		const element = document.getElementById('home');
		ReactModal.setAppElement('#root');
		if (modalIsOpen) {
			if (!!element) element.style.filter = 'blur(5px)';
			if (!!tip?.id) {
				setValue('title', tip?.title);
				setValue('body', tip?.body);
				setValue('explanation', tip?.explanation);
				setValue('categoryId', tip.category?.id);
				setCategoryId(tip.category?.name ?? 'Select');
			}
		} else {
			if (!!element) element.style.filter = 'unset';
		}
	}, [modalIsOpen]);

	// const loadCategories = async () => {
	// 	const resp = await getSolutionCategories();
	// 	if (resp.status === 200) {
	// 		setCategories(resp.data);
	// 	}
	// };

	const onSubmit = async () => {
		let newTip: any = getValues();
		if (tip === null) {
			createUpdateTip(newTip);
		} else {
			newTip.id = tip?.id;
			createUpdateTip(newTip);
		}
	};

	const createUpdateTip = async (data: any) => {
		setProcessing(true);
		const resp = await createUpdateQuickTipsStudent(data);
		if (resp.status === 201) {
			notify(data.id ? 'Tip is updated!' : 'Tip is created!');
			setProcessing(false);
			closeModal();
			reloadTips();
		} else {
			notify(data.id ? 'Tip is not updated!' : 'Tip is not created!');
			setProcessing(false);
		}
	};

	const cleanUpFunction = () => {
		reset();
		setProcessing(false);
		setCategoryId('Select');
	};

	const setSelectedMainCategoryId = (item: any) => {
		setValue('categoryId', item?.id, { shouldValidate: true });
		setCategoryId(!!item?.name ? item.name : 'Select');
	};

	return (
		<ReactModal
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => cleanUpFunction()}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 0,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 900,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='student-info-modal  '>
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div className='close-modal-icon ' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>

				<form onSubmit={handleSubmit(onSubmit)} className='bg-white rounded-xl mx-3 flex-1 flex flex-col gap-5 px-[40px] py-[30px]'>
					<div className='flex flex-row items-center'>
						<div className='flex-1'>
							<p className='text-primaryViolet font-semibold text-3xl text-left'>{tip === null ? 'Create new tip' : 'Edit tip'}</p>
						</div>
					</div>
					<div>
						<div className='mt-4'>
							<div className='flex flex-row items-end justify-between gap-5'>
								<p className={`text-primaryViolet font-semibold text-lg text-left ${errors.title?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}>Title</p>

								<p className='text-redError font-medium text-lg  '>{errors.title?.type === 'required' ? '* This field is required' : ''}</p>
							</div>
							<Controller control={control} name='title' rules={{ required: true }} render={({ field }) => <MDEditor data-color-mode='light' value={field.value} onChange={(value: any) => setValue('title', value, { shouldValidate: true })} preview='edit' />} />
						</div>
						<div className='mt-4'>
							<div className='flex flex-row items-end justify-between gap-5'>
								<p className={`text-primaryViolet font-semibold text-lg text-left ${errors.body?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}>Body</p>

								<p className='text-redError font-medium text-lg  '>{errors.body?.type === 'required' ? '* This field is required' : ''}</p>
							</div>
							<Controller control={control} name='body' rules={{ required: true }} render={({ field }) => <MDEditor data-color-mode='light' value={field.value} onChange={(value: any) => setValue('body', value, { shouldValidate: true })} preview='edit' />} />
						</div>
						<div className='mt-4'>
							<div className='flex flex-row items-end justify-between gap-5'>
								<p className={`text-primaryViolet font-semibold text-lg text-left ${errors.explanation?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}>Explanation</p>

								<p className='text-redError font-medium text-lg  '>{errors.explanation?.type === 'required' ? '* This field is required' : ''}</p>
							</div>
							<Controller control={control} name='explanation' rules={{ required: true }} render={({ field }) => <MDEditor data-color-mode='light' value={field.value} onChange={(value: any) => setValue('explanation', value, { shouldValidate: true })} preview='edit' />} />
						</div>
						<div className='mt-4'>
							<CategoriesDropDown list={categories} register={register} registerField='categoryId' errors={errors.categoryId?.type} label='Categories' selectedValue={categoryId} setSelectedValue={setSelectedMainCategoryId} />
						</div>
					</div>
					<div className='flex flex-row justify-end w-full gap-5 mt-14'>
						{/* <div
							className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer rounded-full bg-[#fafaff]  h-[60px] button-transparent-class'
							onClick={closeModal}
						>
							<p className='text-[18px] text-primaryViolet leading-5 font-semibold mr-3 '>Back</p>
						</div> */}
						<button className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer  rounded-full bg-primaryViolet  min-h-[60px] button-save-class transition' disabled={processing}>
							{processing ? (
								<Loading primaryColor='#FDDF6D' secondaryColor='#5E639B' size={25} stroke={7} />
							) : (
								<div className='flex flex-row items-center justify-center'>
									<p className='text-[18px]  leading-5 font-semibold mr-3 '>Save</p>
									<Save />
								</div>
							)}
						</button>
					</div>
				</form>
			</div>
		</ReactModal>
	);
}

export default CreateEditTipModal;
